import React from 'react';
import { Stack, IconButton, Tooltip } from '@mui/material';
import { Delete as DeleteIcon, DragIndicator as DragIndicatorIcon } from '@mui/icons-material';
import { FormTextField } from '../../../Components/CustomUIElements/FormTextField';
import { theme } from '../../../../ThemeContext/ThemeObject';
import { IFieldChoice } from '../../../Components/sharedTypes';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function SortableChoice({
  choice,
  index,
  handleChoiceInput,
  removeChoice
}: {
  choice: IFieldChoice;
  index: number;
  handleChoiceInput: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
  removeChoice: (index: number) => void;
}) {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id: choice.id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition
  };

  return (
    <Stack
      sx={{ flexDirection: 'row', columnGap: 2, alignItems: 'center' }}
      style={style}
      ref={setNodeRef}
      {...attributes}
    >
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', flexGrow: 1 }}>
        <IconButton
          sx={{ '&:focus': { outline: 'none' } }}
          ref={setActivatorNodeRef}
          {...listeners}
        >
          <DragIndicatorIcon sx={{ fontSize: 18 }} />
        </IconButton>
        <FormTextField
          dataTestId="choice-input"
          value={choice.name}
          onChange={(e) => handleChoiceInput(e, index)}
          required={true}
          fullWidth
        />
      </Stack>
      <Tooltip placement="top" title="Delete" arrow>
        <DeleteIcon
          sx={{ color: theme.palette.error.main, cursor: 'pointer' }}
          onClick={() => removeChoice(index)}
        />
      </Tooltip>
    </Stack>
  );
}
